import React from "react";
import { useRouter } from "next/router";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Paragraph16Bold } from "../../../../../common/Typography/Paragraph16";
import { Paragraph14Regular } from "../../../../../common/Typography/Paragraph14";
import { routes } from "../../../../../routes";
import Icon from "../../../../../common/components/Icon/Icon";

const OptionsContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 21px;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    grid-template-columns: none;
    grid-template-rows: auto auto;
    grid-gap: 21px;
    align-items: center;
  }
`;

const OptionWrapper = styled.div`
  background: ${({ theme }) => theme.lightBackgroundColor};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 243px;
  max-width: 282px;
  cursor: pointer;
  padding: 29px 22px 4px 22px;
  @media (max-width: ${({ theme }) => theme.breakpoints.mobileM}) {
    max-width: 250px;
  }
`;

const OptionTitle = styled(Paragraph16Bold)`
  padding-bottom: 2.7px;
`;

const OptionDescription = styled(Paragraph14Regular)`
  padding-bottom: 22px;
  opacity: 0.7;
`;

const SelectLink = styled(Paragraph16Bold)`
  color: ${({ theme }) => theme.accent.light};
  cursor: pointer;
  text-decoration: none;
`;

const IconContainer = styled.div`
  margin: 0 auto;
  width: 60px;
  height: 60px;
  padding-bottom: 16px;
`;

const SignupOptionsWeb = () => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <OptionsContainer>
      <OptionWrapper onClick={() => router.push(routes.auth.join.signupArtist)}>
        <IconContainer>
          <Icon size="60px" name="signupArtist" />
        </IconContainer>
        <OptionTitle>{t("signup-box-artist-title")}</OptionTitle>
        <OptionDescription>
          {t("signup-box-artist-description")}
        </OptionDescription>
        <SelectLink>{t("signup-box-select-link")}</SelectLink>
      </OptionWrapper>
      <OptionWrapper onClick={() => router.push(routes.auth.join.signupUser)}>
        <IconContainer>
          <Icon size="60px" name="signupCollector" />
        </IconContainer>
        <OptionTitle>{t("signup-box-collector-title")}</OptionTitle>
        <OptionDescription>
          {t("signup-box-collector-description")}
        </OptionDescription>
        <SelectLink>{t("signup-box-select-link")}</SelectLink>
      </OptionWrapper>
    </OptionsContainer>
  );
};

export default SignupOptionsWeb;
